import controllerDataConfigApi from '@/api/config/controllerDataConfig'
import { queryKeys } from '@/constant/common'
import { UpdateController } from '@/types/controller'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'


async function updateController(payload: UpdateController): Promise<void> {
  await controllerDataConfigApi.update(payload)
}

function useUpdateController() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: UpdateController) => updateController(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.controller])
      toast.success(t('UpdateDecoderSuccess'))
      closeSidebar()
    },
    onError: (error: AxiosError<any>) => {
      toast.error(error?.message)
    },
  })
}

export default useUpdateController
